import apiService from "@/api-service";

export class BestekUploader {

    private _busy: boolean = false;
    private _finished: boolean = false;
    private _stopped: boolean = false;
    private _files: FileSystemFileHandle[] = [];

    private _accepted_files: number = 0;
    private _declined_files: number = 0;

    constructor() {}

    public setFiles(files: FileSystemFileHandle[]) {
        this._files = files;
    }

    public stop() {
        this._stopped = true;
        this._busy = false;
    }

    public didFinish() {
        return !this._busy && this._finished;
    }

    public wasCancelled() {
        return this._stopped;
    }

    public isBusy() {
        return this._busy;
    }

    public acceptedFilesCount() {
        return this._accepted_files;
    }

    public declinedFilesCount() {
        return this._declined_files;
    }

    public async delay(milliseconds: number){
        return new Promise(resolve => {
            setTimeout(resolve, milliseconds);
        });
    }

    public async upload() {
        this._stopped = false;
        this._finished = false;
        this._busy = true;
        this._accepted_files = 0;
        this._declined_files = 0;

        let file: FileSystemFileHandle;
        for (file of this._files) {
            if (this._stopped) {
                break;
            }

            let data: File = await file.getFile();
            let formdata = new FormData();
            formdata.append(file.name, data);

            await apiService.post('/bestek/', formdata, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(
                (response) => {
                    if (response.status === 202) {
                        this._accepted_files += 1;
                    } else {
                        this._declined_files += 1;
                    }
                }
            ).catch((e) => {
                this._declined_files += 1;
            }).finally(() => {
                if (this._accepted_files + this._declined_files === this._files.length) {
                    this._busy = false;
                    this._finished = true;
                }
            });
        }
    }
}